export const getInventoryHeaderTab = (searchParams) =>
  searchParams.get('tab') === 'progression' ? 'progression' : 'dashboard';

export const buildInventoryHeaderTabParams = (searchParams, tab) => {
  const next = new URLSearchParams(searchParams);

  if (tab === 'progression') {
    next.set('tab', 'progression');
  } else {
    next.delete('tab');
  }

  return next;
};
